<template>
  <div class='pc_banner'>
    <!-- 搜索 -->
    <div class='pc_select'>
      <el-row>
        <el-col :span='12'
          ><div class='grid-content bg-purple'>
            <el-form
              :inline='true'
              :model='selectForm'
              class='demo-form-inline'
              @submit.native.prevent
            >
              <el-form-item label=''>
                <el-select v-model='selectForm.type' disabled placeholder='搜索条件'>
                  <el-option label='图片所属' value='type'></el-option>
                  <el-option label='设备信息' value='device'></el-option>
                  <el-option label='上线状态' value='status'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type='primary' @click='onSelect' disabled>搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span='10'
          ><div class='grid-content bg-purple'>&nbsp;</div></el-col
        >
        <el-col :span='2'
          ><div class='grid-content bg-purple-light'>
            <div class='cratebtn'>
              <el-button
                type='primary'
                icon='el-icon-plus'
                @click='createEvents'
                >新增一级类目</el-button
              >
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data='getTabeData'
      border
      v-loading='loading'
      style='width: 100%'
    >
      <el-table-column fixed prop='id' label='ID' width='100'></el-table-column>
      <el-table-column prop='device' label='设备信息' width='100'>
        <template slot-scope='scope'>
          <el-tag v-if='scope.row.device === 0'>PC站</el-tag>
          <el-tag type='info' v-if='scope.row.device'>移动站</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop='name' label='一级科目' width='160'>
      </el-table-column>
      <el-table-column prop='status' label='状态' width='100'>
        <template slot-scope='scope'>
          <el-tag type='success' v-if='scope.row.status === 0'>上线</el-tag>
          <el-tag type='warning' v-else>待上线</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop='create_time' label='创建时间'>
      </el-table-column>
      <el-table-column prop='update_time' label='更新时间'>
      </el-table-column>
      <el-table-column fixed='right' label='操作' width='120'>
        <template slot-scope='scope'>
          <el-tooltip class='item' effect='dark' content='编辑' placement='top'>
            <el-button
              type='success'
              icon='el-icon-edit'
              size="small"
              @click='handleClick(scope.row.id)'
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class='pc_pages'>
      <div class='block'>
        <!-- <span class='demonstration'>完整功能</span> -->
        <el-pagination
          @size-change='handleSizeChange'
          @current-change='handleCurrentChange'
          :current-page='currentPage'
          :page-sizes='sizes'
          :page-size='sizePage'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :title='title'
      :visible.sync='EditorDialogVisible'
      width='45%'
      @closed='closed("editorForm")'
    >
      <!-- 编辑实现显示区 -->
      <div class='editor'>
        <el-form
          :label-position='"lift"'
          label-width='110px'
          :model='editorForm'
          ref="editorForm"
          :rules="ruleForm"
        >
          <el-form-item label='ID' prop="id">
            <el-input v-model='editorForm.id' :disabled='true'></el-input>
          </el-form-item>
          <el-form-item label='设备信息' prop="device">
            <el-select v-model='editorForm.device' placeholder='请选择设备信息'>
            <el-option label='移动站' value='1'></el-option>
            <el-option label='PC站' value='0'></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label='一级科目名称' prop="name">
             <el-input v-model='editorForm.name'></el-input>
          </el-form-item>
          <el-form-item label='状态' >
            <el-select v-model='editorForm.status' placeholder='请选择状态'>
              <el-option label='上线' value='0'></el-option>
              <el-option label='待上线' value='1'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='上次更新时间' prop="update_time">
            <el-input
              v-model='editorForm.update_time'
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='EditorDialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='EditorSubmit("editorForm")'>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增的弹出框 -->
    <el-dialog
      :title='title'
      :visible.sync='createEventDialog'
      @closed='closed("createForm")'
    >
      <el-form :model='newEventForm' label-width='110px' ref='createForm' :rules="ruleForm">
        <el-form-item label='设备信息' prop="device">
          <el-select v-model='newEventForm.device' placeholder='请选择设备信息'>
            <el-option label='PC站' value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='一级类目名称' prop="name">
          <el-input
            placeholder='请输入内容'
            v-model='newEventForm.name'
          >
          </el-input>
        </el-form-item>
        <el-form-item label='上线状态' prop="status">
          <el-select v-model='newEventForm.status' placeholder='请选择上线状态'>
            <el-option label='上线' value='0'></el-option>
            <el-option label='待上线' value='1'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='createEventDialog = false'>取 消</el-button>
        <el-button type='primary' @click='createEvent("createForm")'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { pcCategorys } from 'untils/form_validation.js';
import { initCoursList,findCours,saveCours } from 'api/post/postApi.js';
export default {
  name: 'pc_cat_one',
  components: { },
  data() {
    return {
      loading: true,
      tableData: [],
      // 分页功能参数
      total: 0,
      sizes: [10, 20, 30, 40],
      sizePage: 10,
      currentPage: 1,
      selectForm: {
        type: ''
      },
      EditorDialogVisible: false,
      createEventDialog: false,
      editorForm: {},
      ruleForm:null,
      newEventForm: {
        device:'0'
      },
      title: ''
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  // 计算属性
  computed: {
    // 分页控制
    getTabeData: function () {
      const tableData = this.tableData.slice(
        (this.currentPage - 1) * this.sizePage,
        this.currentPage * this.sizePage
      );
      return tableData;
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initCoursList();
      this.tableData = res.data;
      this.total = res.data.length;
      this.loading = false;
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 编辑
    async handleClick(cid) {
      this.title = '编辑一级目录';
      this.ruleForm=pcCategorys;
      const params = { id:cid }; // 构造参数
      const { data: res } = await findCours(params);
      this.editorForm = res.data;
      // 修改数据类型，以作数据回显
      this.editorForm.status = this.editorForm.status.toString();
      this.editorForm.device=this.editorForm.device.toString();
      this.EditorDialogVisible = true;
    },
    // 更新
    EditorSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          const { data: res } = await saveCours(this.editorForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('更新失败！');
          } else {
            this.$message.success('更新成功！');
            this.initData();
          }
          this.EditorDialogVisible = false;

        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });

    },
    // 公用的dialog清空逻辑
    closed(formName) {
      this.editorForm = {};
      this.newEventForm= {
        device:'0'
      };
      this.resetForm(formName);
    },
    // 删除
    // async handleDeleteClick(id) {
    //   // 询问用户是否删除数据
    //   const confirmResult = await this.$confirm(
    //     '此操作将永久删除该信息, 是否继续?',
    //     '提示',
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning',
    //     }
    //   ).catch((err) => err);
    //   if (confirmResult !== 'confirm') {
    //     return this.$message.info('已取消删除！');
    //   }
    //   const { data: res } = await this.$http.post('', {
    //     id: id,
    //   });
    //   if (res.status !== 0) {
    //     // elementui组件 消息框
    //     this.$message.error('删除失败！');
    //   } else {
    //     this.$message.success('删除成功！');
    //   }
    //   this.initData();
    // },
    // 新增按钮
    createEvents() {
      this.title='新增一级目录';
      this.ruleForm=pcCategorys;
      this.createEventDialog = true;
    },
    // 提交新增表单
    createEvent(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          const { data: res } = await saveCours(this.newEventForm);
          if (res.status !== 0) {
            // elementui组件 消息框
            this.$message.error('新增失败！');
          } else {
            this.$message.success('新增成功！');
            this.initData();
          }
          this.createEventDialog = false;

        } else {
          this.$message.error('表单验证未通过！');
          return false;
        }
      });

    },
    // 清除验证规则
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    // 搜索实现
    onSelect() {
    }
  }
};
</script>

<style scoped>
.pc_pages {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.pc_select {
  width: 100%;
}
.imgs {
  width: 160px;
  height: 160px;
}
.img_show {
  width: 300px;
  height: 200px;
}
.cratebtn {
  float: right;
}
</style>